import { z } from 'zod';
import {
  StreamTableSchema,
  superRefineStreamTableSchema,
} from '../StreamTableSchema';
import {
  CustomFunctionSchema,
  FieldSpecSchema,
  JSONExtractionsSchema,
  PreserveUnreferencedColumnsSchema,
  TemporaryFieldSchema,
} from './Common';

export const PreTransformSchemaShape = z
  .object({
    usePreset: z.string().optional(),
    filter: z.string().optional(),
    postFilter: z.string().optional(),
    omitFields: z.array(z.string().optional()).optional(),
    addFields: z.array(FieldSpecSchema).optional(),
    bronzeTables: z.array(StreamTableSchema),
    method: z.enum(['configure', 'none', 'custom']),
    customNotebookPath: z.string().optional(),
  })
  .merge(JSONExtractionsSchema)
  .merge(PreserveUnreferencedColumnsSchema)
  .merge(CustomFunctionSchema)
  .merge(TemporaryFieldSchema);

export const PreTransformSchema = PreTransformSchemaShape.superRefine(
  (data, ctx) => {
    if (data.embed && !data.embedColumn) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Column is required',
        path: ['embedColumn'],
      });
    }

    if (data.preserve && data.embed && !data.embedColumn) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Column is required',
        path: ['embedColumn'],
      });
    }

    data.jsonExtract.forEach((jsonExtract, index) => {
      if (jsonExtract.embed && !jsonExtract.embedColumn) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'A destination column is required',
          path: ['jsonExtract', index + '', 'embedColumn'],
        });
      }
    });

    if (data.method === 'custom' && !data.customFunction) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'A custom function is required',
        path: ['customFunction'],
      });
    }

    data.bronzeTables.forEach((bronzeTable, index) => {
      if (!bronzeTable.joinExpr) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Join expression is required',
          path: ['bronzeTables', index, 'joinExpr'],
        });
      }
      if (!bronzeTable.joinType) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Join type is required',
          path: ['bronzeTables', index, 'joinType'],
        });
      }
    });

    superRefineStreamTableSchema(data.bronzeTables, ctx, 'bronzeTables', -1);
  },
);

export type PreTransformSchemaFormValues = z.infer<typeof PreTransformSchema>;
